import { useQuery } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { SmartInsightsResponse } from 'src/reactQuery/useGetSmartInsightsQuery'
import { analyticsApi } from 'src/services/analyticsApi'

const getAdsLibrarySmartInsights = async (
  pageId?: string
): Promise<SmartInsightsResponse | null> => {
  const sessionId = getSessionIdFromLocalStorage()
  if (!sessionId) return null

  const { data } = await analyticsApi().get<SmartInsightsResponse>(
    '/v1_private/ads-library/smart-insights',
    { params: { page_id: pageId } }
  )

  return data
}

// The backend serves two distinct scopes: with `page_id` it returns that
// advertiser page's insights (shared across every user monitoring it); without
// it, the requesting user's brand-wide set. Advertiser detail pages MUST pass
// their pageId — omitting it silently serves brand-wide insights on a
// page-scoped view.
export const useGetAdsLibrarySmartInsightsQuery = (pageId?: string) => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId,
    queryFn: () => getAdsLibrarySmartInsights(pageId),
    queryKey: [QueryKey.GET_ADS_LIBRARY_SMART_INSIGHTS, pageId ?? ''],
  })
}
